import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Form, Nav, Navbar, NavDropdown, Offcanvas} from 'react-bootstrap'
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger, Flip } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, Flip, useGSAP);


export default function ButtonAppBar() {
  const location = useLocation();
  
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const container = useRef<HTMLDivElement | null>(null);

  
  return (
    <>
    <Navbar collapseOnSelect expand="lg"  fixed="top" className="navbar" ref={container}>
       <Container className="navbar-content">
        <Navbar.Toggle className='navbar-hambergure' aria-controls={'offcanvasNavbar-expand-false'} onClick={handleShow} />
        <Link to={'/'}><img id="logo" src={require('../../assets/Fatteh-Logo.webp')} alt='fatte logo' /></Link>
        <Navbar.Offcanvas
            id='offcanvasNavbar-expand-false'
            aria-labelledby='offcanvasNavbarLabel-expand-false'
            placement="start"
            backdrop={false}
            
            show={show}
          >
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Link as={Link} to="/news" onClick={handleClose}>News</Nav.Link>
                <Nav.Link as={Link} to="/magazine" onClick={handleClose}>Magazine</Nav.Link>
                <Nav.Link as={Link} to="/about" onClick={handleClose}>About us</Nav.Link>
                <Nav.Link as={Link} to="/get-involved" onClick={handleClose}>Get involved</Nav.Link>
                <Nav.Link as={Link} to="/contact" onClick={handleClose}>Contact us</Nav.Link>
              </Nav>
            </Offcanvas.Body>
            
          </Navbar.Offcanvas>
       </Container>
    </Navbar>
    </>
  );
}
